/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable react/jsx-boolean-value */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './CabsBookingPage.scss';
import { Col, Row, Table } from 'react-bootstrap';
import SelectedCabCard from '../search-results/SelectedCabCard';
import {
  CABS_PAX,
  checkValidEmailAddress,
  checkValidMobileNumber,
  NAVIGATION_ROUTES,
} from '../../../shared/constants/Constants';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import { useIntl } from 'react-intl';
import CabsPassengerDetails from './CabsPassengerDetails';
import {
  formatCurrency,
  getEligibilityForPaymentMode,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import { CiBank, CiWallet } from 'react-icons/ci';
import { MdOutlineCreditCard } from 'react-icons/md';
import PaymentGatewayApii from '../../hotels/booking-review/PaymentGatewayApii';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import {
  NET_BANKING_OPTIONS,
  NET_BANKING_OPTIONS_LIVE,
} from '../../../shared/constants/NetBankingOptions';
import AppButton from '../../../shared/components/app-button/AppButton';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import { getUserDetails } from '../../../api/profileApi';
import AppModal from '../../../shared/components/app-modal/AppModal';
import { getPGCheckOutAmountApi } from '../../../api/flightApi';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import { bookCabsApi } from '../../../api/cabApi';

function CabsBookingPage() {
  const navigate = useNavigate();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const { state } = useLocation();
  const { searchRequest, repriceResponse } = state;
  const cab = repriceResponse.transferInfoList[0];
  const [paxList, setPaxList] = useState([]);
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [leadmobile, setLeadmobile] = useState('');
  const [leademail, setLeademail] = useState('');
  const [errorsObj, setErrorsObj] = useState({});
  const [passengerErrorDict, setPassengerErrorDict] = useState({});
  const [agent, setAgent] = useState({});
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);
  const [paymentMode, setPaymentMode] = useState('cashcard');
  const [selectedPg, setSelectedPg] = useState('');
  const [selectedBankForNetBanking, setSelectedBankForNetBanking] =
    useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [checkoutPgCharge, setcheckoutPgCharge] = useState(0);
  const [checkoutgstPgCharge, setgstcheckoutPgCharge] = useState(0);
  const [checkoutInvTotal, setcheckoutInvTotal] = useState(0);
  const fareSummaryRef = useRef({});

  const getAgentDetails = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      if (!isEmpty(User)) {
        setAgent(User);
      }
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getAgentDetails();
    const noofAdults = Number(searchRequest.adults);
    const noofChilds = Number(searchRequest.childs);
    const paxListArray = [];
    if (noofAdults > 0) {
      Array.from({ length: noofAdults }, (v, k) => k).forEach((idx) => {
        paxListArray.push({
          ...CABS_PAX,
          paxtype: 'Adult',
          ...(idx === 0 && { isLead: true }),
        });
      });
    }
    if (noofChilds > 0) {
      Array.from({ length: noofChilds }, (v, k) => k).forEach((index) => {
        paxListArray.push({
          ...CABS_PAX,
          paxtype: 'Child',
          age: Number(searchRequest.childAges[index]),
        });
      });
    }
    setPaxList(paxListArray);
    fareSummaryRef.current = {
      totalFare: cab.nextraTotalPrice,
    };
  }, []);
  const onPassengerUpdate = (list) => {
    setPaxList(list);
  };
  const handlePgSelect = (pgName) => {
    setSelectedPg(pgName);
  };

  const checkValidationsAndProceed = async () => {
    setIsLoading(true);
    const errorDict = [];
    const errorsObject = {};
    if (leadmobile === '') {
      errorsObject.phone = formattedMessage('enter_phone_number');
    }
    if (checkValidEmailAddress(leademail)) {
      errorsObject.validEmail = formattedMessage('email_id_validation');
    }
    if (checkValidMobileNumber(leadmobile)) {
      errorsObj.validPhoneNumber = formattedMessage('enter_valid_phone_number');
    }
    paxList.forEach((pax, index) => {
      const errors = {};
      if (!pax.title) {
        errors.title = formattedMessage('passenger_title_required');
      }
      if (!pax.firstname) {
        errors.firstname = formattedMessage('passenger_first_name_required');
      }
      if (!pax.lastname) {
        errors.lastname = formattedMessage('passenger_last_name_required');
      }
      if (Object.keys(errors).length > 0) {
        errorDict[index] = errors;
      }
    });
    setPassengerErrorDict(errorDict);
    setErrorsObj(errorsObj);
    if (Object.keys(errorsObj).length === 0 && errorDict.length === 0) {
      let bankId = '';
      if (
        paymentMode === 'netbanking' &&
        (selectedPg === 'techprocessv2' ||
          selectedPg === 'techprocessv2_netbanking' ||
          selectedPg === 'payu')
      ) {
        bankId = selectedBankForNetBanking;
      }
      const pgcheckoutamount = await getPGCheckOutAmountApi(
        paymentMode,
        selectedPg,
        '',
        cab.nextraTotalPrice,
        'hotel',
        getUserAgentId(),
        bankId,
      );
      if (pgcheckoutamount?.ApiStatus?.Status === 'OK') {
        setIsLoading(false);
        const { Result = {} } = pgcheckoutamount.ApiStatus;
        setcheckoutPgCharge(Result.PgCharges);
        setgstcheckoutPgCharge(Result.GSTOnPgCharges);
        setcheckoutInvTotal(Result.TotalInvoice);
      }
      if (
        Object.keys(errorsObj).length === 0 &&
        Object.keys(errorDict).length === 0
      ) {
        // bookAHotel();
        setIsLoading(false);
        setShowConfirmationPopup(true);
      }

      // onBookNow();
    } else {
      setAlert({
        variant: 'error',
        title: 'Rail Book',
        description: 'Enter all mandatory fields',
      });
      return false;
    }
  };

  useEffect(() => {
    document.querySelectorAll('.watermarked').forEach((el) => {
      el.dataset.watermark = (el.dataset.watermark + ' ').repeat(400);
    });
  }, []);

  const bookNow = async () => {
    setIsLoading(true);
    const request = {
      repriceResponseId: repriceResponse.repriceResponseId,
      faresource: cab.fareSource.toString(),
      pickuptime: cab.datetimeDetails.pickup_time,
      pickuppoint: cab.pickupLocation.placeId,
      droppoint: cab.dropOfLocation.placeId,
      vechicaltype: cab.vehicleDetails.serviceType,
      transfertime: '1',
      orgininfo: cab.pickupLocation.address,
      destinfo: cab.dropOfLocation.address ? cab.dropOfLocation.address : '',
      description: '',
      totalnet: cab.nextraTotalPrice,
      adults: searchRequest.adults,
      child: searchRequest.childs,
      cancellationPolicy: cab.cancellationPolicy,
      city: '',
      country: '',
      name: cab.vehicleDetails.name,
      stratdate: cab.datetimeDetails.pickup_date,
      nextraroombreakupenc: cab.nextrabreakupenc,
      nextratotal: cab.nextraTotalPrice,
      nextrafarequote: cab.nextrafarequotetotal,
      basecurrency: cab.vehicleFare.baseCurrency,
      transfers: [
        {
          vehicleBookingKey: cab.vehicleBookingKey,
          supplements: cab.supplements,
        },
      ],
      paxlist: paxList,
    };
    const response = await bookCabsApi(request, paymentMode);
    if (response.Root.StatusCode === 200) {
      setAlert({
        variant: 'success',
        title: 'Success',
        description: response.Root.Message,
      });
      if (paymentMode === 'cashcard') {
        const url = NAVIGATION_ROUTES.CABS.CABS_VOUCHER.replace(
          ':transactionId',
          response.Root.Result,
        );
        setTimeout(() => {
          navigate(url);
        }, 2000);
      } else {
        const { Result } = response.Root;
        if (Result !== '') {
          const { PgUrl, Txid } = Result;
          let urlToRedirect = `${PgUrl}?txid=${Txid}`;
          if (paymentMode === 'netbanking') {
            urlToRedirect += `&bankcode=${selectedBankForNetBanking}`;
          }
          window.open(urlToRedirect, '_blank');
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Error',
        description: response.Root.Message,
      });
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <AppLoading isLoading={isLoading} />}
      {alert && (
        <AppAlert
          showIcon
          onHide={() => setAlert(undefined)}
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
        />
      )}
      <div className="cab-booking-page">
        <div className="cab-booking-page__header" />
        <Row className="cab-container pt-4">
          <Col lg={9} md={9} sm={9} xs={12}>
            <SelectedCabCard cab={cab} searchRequest={searchRequest} />
            <div className="seperator" />
            <div className="cab-booking-page__section">
              <p className="fw-600">Passenger Details</p>
              <div className="mt-2">
                <div>
                  {paxList && paxList.length > 0 && (
                    <CabsPassengerDetails
                      paxList={paxList}
                      onPassengerUpdate={onPassengerUpdate}
                      passengerErrorDict={passengerErrorDict}
                    />
                  )}
                </div>
              </div>
              <div className="mt-4">
                <div className="fw-600">Contact Details</div>
                <Row className="mt-2">
                  <Col lg={3} md={3} sm={3} xs={12}>
                    <AppTextInput
                      className="contact-input"
                      name="leadmobile"
                      id="leadmobile"
                      required
                      label="Mobile Number"
                      value={leadmobile}
                      // onChange={(event) => setLeadmobile(event.target.value)}
                      onChange={(event) => {
                        setLeadmobile(event.target.value);
                        setPaxList((prev) =>
                          prev.map((pax, idx) =>
                            idx === 0
                              ? {
                                  ...pax,
                                  phone: event.target.value,
                                  mobile: event.target.value,
                                }
                              : pax,
                          ),
                        );
                      }}
                      errorText={errorsObj.phone || errorsObj.validPhoneNumber}
                    />
                    {checkValidMobileNumber(leadmobile) && (
                      <small className="app-error-text">
                        {formattedMessage('enter_valid_mobile_number')}
                      </small>
                    )}
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={12}>
                    <AppTextInput
                      className="contact-input"
                      name="leademail"
                      id="leademail"
                      required
                      label="Email ID"
                      value={leademail}
                      // onChange={(event) => setLeademail(event.target.value)}
                      onChange={(event) => {
                        setLeademail(event.target.value);
                        setPaxList((prev) =>
                          prev.map((pax, idx) =>
                            idx === 0
                              ? { ...pax, email: event.target.value }
                              : pax,
                          ),
                        );
                      }}
                      errorText={errorsObj.email || errorsObj.validEmail}
                    />
                    {checkValidEmailAddress(leademail) && (
                      <small className="app-error-text">
                        {formattedMessage('email_id_validation')}
                      </small>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
            <div className="seperator" />
            <div className="cab-booking-page__section">
              <div>
                <div className="py-2 px-3 fs-5 fw-600">Payment options</div>
                <div className="d-flex cursor-pointer">
                  {getEligibilityForPaymentMode('wallet') && (
                    <div
                      className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center  fw-500 ${
                        paymentMode === 'cashcard'
                          ? 'primary-color'
                          : 'grey-color'
                      }`}
                      onClick={() => setPaymentMode('cashcard')}
                    >
                      <CiWallet />
                      Wallet
                    </div>
                  )}
                  {getEligibilityForPaymentMode('creditcard') && (
                    <div
                      className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                        paymentMode === 'creditcard'
                          ? 'primary-color'
                          : 'grey-color'
                      }`}
                      onClick={() => setPaymentMode('creditcard')}
                    >
                      {' '}
                      <MdOutlineCreditCard /> CreditCard
                    </div>
                  )}
                  {getEligibilityForPaymentMode('debitcard') && (
                    <div
                      className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                        paymentMode === 'debitcard'
                          ? 'primary-color'
                          : 'grey-color'
                      }`}
                      onClick={() => setPaymentMode('debitcard')}
                    >
                      {' '}
                      <MdOutlineCreditCard /> DebitCard
                    </div>
                  )}
                  {getEligibilityForPaymentMode('netbanking') && (
                    <div
                      className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                        paymentMode === 'netbanking'
                          ? 'primary-color'
                          : 'grey-color'
                      }`}
                      onClick={() => setPaymentMode('netbanking')}
                    >
                      <CiBank />
                      Netbanking
                    </div>
                  )}
                  {getEligibilityForPaymentMode('upi') && (
                    <div
                      className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center  fw-500 ${
                        paymentMode === 'upi' ? 'primary-color' : 'grey-color'
                      }`}
                      onClick={() => setPaymentMode('upi')}
                    >
                      <CiBank />
                      UPI
                    </div>
                  )}
                </div>
                {paymentMode !== 'cashcard' && paymentMode !== '' && (
                  <PaymentGatewayApii
                    paymentModeClicked={paymentMode}
                    selectedPgForPaymentMode={selectedPg}
                    onPgSelect={handlePgSelect}
                  />
                )}
                {paymentMode === 'netbanking' &&
                  paymentMode !== 'cashcard' &&
                  paymentMode !== '' && (
                    <div className="d-flex justify-content-start p-3">
                      <AppSelect
                        name="selected_bank"
                        id="selected_bank"
                        label="Select Bank"
                        placeholder=""
                        required
                        selectWidth="300px"
                        isClearable={false}
                        options={NET_BANKING_OPTIONS_LIVE}
                        selectedValue={selectedBankForNetBanking}
                        onSelect={(dataObj) =>
                          setSelectedBankForNetBanking(dataObj.value)
                        }
                      />
                    </div>
                  )}
                {paymentMode !== '' &&
                  paymentMode !== 'cashcard' &&
                  selectedPg === 'payu' && (
                    <div className="px-3 d-flex flex-column">
                      <p className="mb-2 px-4 fs-14">
                        Accept Terms and Conditions of <b>payu</b>
                      </p>
                      <AppCheckBox
                        labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                        id="payuPgAccepted"
                        name="payuPgAccepted"
                        radioClassName="w-25px"
                        checked={isPayuPgAccepted}
                        labelClassName="fs-12"
                        onChange={() => setIsPayuPgAccepted((prev) => !prev)}
                      />
                      <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                        <img
                          src="/images/others/payu.jpg"
                          alt=""
                          height="20px"
                        />
                        <img
                          src="/images/others/visa_mastercard.gif"
                          alt=""
                          height="20px"
                        />
                        <span>
                          (Only Personal Credit Cards @ 1.77% | Rupay Debit Card
                          allowed @0.25%)
                        </span>
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div className="seperator" />
            <div className="cab-booking-page__section">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <AppCheckBox
                    labelText={formattedMessage(
                      'i_have_read_and_accept_terms_and_conditions',
                    )}
                    id="acceptTerms"
                    name="acceptTerms"
                    checked={acceptTerms}
                    labelClassName="fs-12"
                    onChange={() => setAcceptTerms((prev) => !prev)}
                  />
                </div>
                <div>
                  <AppButton
                    btnText="Confirm"
                    disabled={!acceptTerms}
                    onClick={() => checkValidationsAndProceed()}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} md={3} sm={3} xs={12}>
            <section className="cab-fare-summary-section">
              <div className="fare-summary_container flex-1">
                <div className="fare-summary_title d-flex justify-content-between align-items-center">
                  <span>{formattedMessage('fare_summary_caps')}</span>
                  {/* <AppIconButton
                    className="p-0 fs-16"
                    variant="white"
                    // onClick={() => setShowNetFare((prev) => !prev)}
                  >
                  {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                  </AppIconButton> */}
                </div>
                <div
                  className="fare-summary_table watermarked"
                  data-watermark={getUserAgentId()}
                >
                  <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between">
                      <span>Total Fare</span>
                      <span className="fw-500">
                        {formatCurrency(fareSummaryRef.current.totalFare)}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="fare-summary_footer watermarked"
                  data-watermark={getUserAgentId()}
                >
                  <div className="d-flex justify-content-between spacing-0">
                    <span className="fare-summary_footer_title">
                      {formattedMessage('total_fare')}
                    </span>
                    <span className="fare-summary_footer_value d-flex flex-column">
                      <span>
                        {formatCurrency(fareSummaryRef.current.totalFare)}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </div>
      {showConfirmationPopup && (
        <AppModal
          onModalClose={() => setShowConfirmationPopup(false)}
          size="lg"
          modalTitle="Confirm Booking"
        >
          <SelectedCabCard cab={cab} searchRequest={searchRequest} />
          <div className="seperator" />
          <div className="fs-16 fw-500">Passenger Details</div>
          <div className="cab-section">
            <Table>
              <thead>
                <tr>
                  <th>Sno</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {paxList.length > 0 &&
                  paxList.map((pax, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {pax.title} {pax.firstname} {pax.lastname}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <div className="seperator" />
          <div className="d-flex gap-2 justify-content-end mt-4">
            <AppButton
              btnText="Cancel"
              variant="outlined"
              onClick={() => setShowConfirmationPopup(false)}
            />
            <AppButton btnText="Book Now" variant="primary" onClick={bookNow} />
          </div>
        </AppModal>
      )}
    </>
  );
}

export default CabsBookingPage;
